import type { UseMutationResult } from '@tanstack/react-query';
import type { ProjectConferenceTagWithMetadata } from '@trinity/chat/api/interfaces/projects';
import { createNamedContext } from '@trinity/chat-components';
import type { ProjectTagsActions, TagStateValue } from './interfaces';

type ContextValue = {
  projectId: number;
  state: TagStateValue;
  dispatch: React.Dispatch<ProjectTagsActions>;
};

export type TagFormData = {
  title: string;
  parentId: number;
  category: string;
  includeSummary: boolean;
  color: string;
};

type TagFormContextValue = {
  data: TagFormData;
  dispatch: React.Dispatch<Partial<TagFormData>>;
};

export type UpdateTagParams = {
  includeSummary?: boolean;
  color?: string;
  hidden?: boolean;
  tagCategory?: string;
  title?: string;
  tagId: number;
  parentId: number;
};

type UpdateTagContextValue = UseMutationResult<{ tag: ProjectConferenceTagWithMetadata }, unknown, UpdateTagParams, unknown>;

export const TagStateContext = createNamedContext<ContextValue>(undefined, 'Tag.State.Context');
export const TagFormContext = createNamedContext<TagFormContextValue>(undefined, 'Tag.Form.Context');
export const UpdateTagContext = createNamedContext<UpdateTagContextValue>(undefined, 'Tag.Update.Context');